// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2383) return "static/chunks/2383.9185970279d6867c.js";
	if (chunkId === 5637) return "static/chunks/5637.0a4b85d45c6d4484.js";
	if (chunkId === 4708) return "static/chunks/4708.11ce8077cbb4d399.js";
	if (chunkId === 1840) return "static/chunks/1840.ae8b151a46989086.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"887":"10f39aee7bc045b0","1095":"69de2240217caf0e","2568":"3c8d5c96b4f1ce05","5634":"4042c0c18109bd2b","5732":"515dff705b258c09","5782":"039cc1b4687964a9","7654":"a39812020af32666","8499":"4036b5088cfa74b3"}[chunkId] + ".js";
};